/**
 * 环境配置
 */

export interface EnvConfig {
  baseURL: string;
  apiTimeout: number;
}

/**
 * 获取当前环境配置
 */
// 开发环境配置
const DEV_CONFIG: EnvConfig = {
  baseURL: 'http://115.29.210.221:8201',
  apiTimeout: 10000,
};

// 生产环境配置（同域名走 Nginx，接口路径本身已带 /api）
const PROD_CONFIG: EnvConfig = {
  baseURL: 'https://appraisal.hzbaieji.com',
  apiTimeout: 15000,
};

export const getEnvConfig = (): EnvConfig => {
  const isDev = process.env.NODE_ENV === 'development';

  if (isDev) {
    console.log('🚀 当前环境: 开发环境 (Development)');
    console.log('📡 API地址:', DEV_CONFIG.baseURL);
    return DEV_CONFIG;
  } else {
    console.log('🏭 当前环境: 生产环境 (Production)');
    console.log('📡 API地址:', PROD_CONFIG.baseURL);
    return PROD_CONFIG;
  }
};

/**
 * 获取 API 基础 URL
 */
export const getBaseURL = (): string => {
  return getEnvConfig().baseURL;
};

/**
 * 判断是否为开发环境
 */
export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV === 'development';
};

/**
 * 判断是否为生产环境
 */
export const isProduction = (): boolean => {
  return process.env.NODE_ENV === 'production';
};